import * as Yup from 'yup';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { InputTextField } from '@/components/UI/InputTextField';
import { RoundButton } from '@/components/UI/RoundButton';
import { RoundLink } from '@/components/UI/RoundLink';
import './index.scss';

const VALIDATION_SCHEMA = t =>
  Yup.object().shape({
    email: Yup.string()
      .email(t('forgot_password.email_not_valid'))
      .required(t('forgot_password.please_fill_in_the_field')),
  });

const ForgotPasswordForm = ({ onSubmit }) => {
  const { t } = useTranslation('auth');
  return (
    <Formik
      initialValues={{ email: '' }}
      validationSchema={VALIDATION_SCHEMA(t)}
      onSubmit={(values, formikBag) => onSubmit(values, formikBag)}
    >
      {({ values, errors, touched, handleChange, handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <h1 className="forgot-password_form__title f-500">
            {t('forgot_password.restore_password')}
          </h1>
          <p className="forgot-password_form__description">
            {t('forgot_password.enter_registered_email')}
          </p>
          <InputTextField
            label={t('forgot_password.email')}
            name="email"
            value={values.email}
            onChange={handleChange}
            className="forgot-password_form__email"
            error={errors.email && touched.email && errors.email}
          />
          <RoundButton
            label={t('forgot_password.send_email')}
            onSubmit={handleSubmit}
            className="forgot-password_form__submit"
            fillBackground
            fullWidth
            type="submit"
          />
          <div className="forgot-password_form__bottom">
            <div>{t('forgot_password.remembered_password')}</div>
            <RoundLink label={t('forgot_password.sign_in')} path="/sign-in" />
          </div>
        </form>
      )}
    </Formik>
  );
};

export default ForgotPasswordForm;
